import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { DischargePlanningQuestionnaireItem } from './questionnaire'
import { RecertFormData } from '../../types/RecertFormData'
import { RecertFormField } from '../../types/RecertFormField'

export class DischargePlanningAdapter extends SectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const dischargePlans = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS
    )?.at(0)
    const rehabilitationPotential = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
    )?.at(0)
    const notes = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES
    )?.at(0)
    return {
      [RecertFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]: dischargePlans,
      [RecertFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]: rehabilitationPotential,
      [RecertFormField.DISCHARGE_PLANNING_NOTES]: notes
    }
  }

  buildFlatAnswers(formData: RecertFormData): FlatAnswerMutation[] {
    return [
      {
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS,
        value: formData[RecertFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]
      },
      {
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL,
        value: formData[RecertFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]
      },
      {
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES,
        value: formData[RecertFormField.DISCHARGE_PLANNING_NOTES]
      }
    ]
  }
}
